import React, {FC} from 'react';

import {InputString} from '@zoefin/design-system';

import {INPUT_THEME} from '../../constants';
import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';
import type {FhsField} from '../../types';

import styles from './styles.module.scss';

interface QuestionTextProps {
  field: FhsField;
  label?: string;
  placeholder?: string;
}

const QuestionText: FC<QuestionTextProps> = ({field, label, placeholder}) => {
  const actor = useFhsActor();
  const {formData, errors, touched} = useFhs();

  const raw = formData[field];
  const value = typeof raw === 'string' ? raw : '';
  const error = touched[field] ? errors[field] : undefined;

  return (
    <div className={styles.questionText}>
      <InputString
        id={`fhs-${field}`}
        name={field}
        label={label}
        placeholder={placeholder}
        theme={INPUT_THEME}
        value={value}
        maxLength={100}
        hasError={Boolean(error)}
        errorMessage={error}
        className={styles.questionText__input}
        onChange={(newValue) => {
          actor.send({
            type: 'UPDATE_FIELD',
            field,
            value: newValue.target.value,
          });
        }}
      />
    </div>
  );
};

export default QuestionText;
